import React, { useState } from 'react';
import { Button } from './Button';
import { motion } from 'framer-motion';
interface ContactFormProps {
  title?: string;
  subtitle?: string;
}
export function ContactForm({
  title = 'Get A Free Strategy Call'
}: ContactFormProps) {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    phone: '',
    dealershipname: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      alert('Thank you! Your strategy call request has been received. We will contact you shortly.');
      setFormState({
        name: '',
        email: '',
        phone: '',
        dealershipname: ''
      });
    }, 1500);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value
    });
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.6
  }} className="bg-white p-8 rounded-xl shadow-2xl w-full border-t-4 border-[#D4AF37]" data-id="element-22">
      <div className="mb-6 text-center" data-id="element-23">
        <h3 className="text-2xl font-bold text-[#0A1628] mb-2 font-playfair" data-id="element-24">
          {title}
        </h3>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4" data-id="element-25">
        <div data-id="element-26">
          <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-27">
            Name
          </label>
          <input type="text" id="name" name="name" required value={formState.name} onChange={handleChange} className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-[#D4AF37] focus:border-transparent outline-none transition-all bg-gray-50 focus:bg-white" placeholder="Your Name" data-id="element-28" />
        </div>

        <div data-id="element-29">
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-30">
            Email
          </label>
          <input type="email" id="email" name="email" required value={formState.email} onChange={handleChange} className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-[#D4AF37] focus:border-transparent outline-none transition-all bg-gray-50 focus:bg-white" placeholder="your@email.com" data-id="element-31" />
        </div>

        <div data-id="element-32">
          <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-33">
            Phone
          </label>
          <input type="tel" id="phone" name="phone" required value={formState.phone} onChange={handleChange} className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-[#D4AF37] focus:border-transparent outline-none transition-all bg-gray-50 focus:bg-white" placeholder="(555) 123-4567" data-id="element-34" />
        </div>

        <div data-id="element-35">
          <label htmlFor="dealershipname" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-36">
            Dealership Name
          </label>
          <input type="text" id="dealershipname" name="dealershipname" required value={formState.dealershipname} onChange={handleChange} className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-[#D4AF37] focus:border-transparent outline-none transition-all bg-gray-50 focus:bg-white" placeholder="Bay Marine Sales" data-id="element-37" />
        </div>

        <div className="pt-2" data-id="element-38">
          <Button type="submit" fullWidth isLoading={isSubmitting} className="bg-[#D4AF37] hover:bg-[#b5952f] text-white font-bold py-4 text-lg shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1" data-id="element-39">
            Book Strategy Call
          </Button>
          <p className="text-xs text-gray-400 text-center mt-3" data-id="element-40">
            We respect your privacy.
          </p>
        </div>
      </form>
    </motion.div>;
}